export function playSound(ary, name, options={}) {
	const found = ary.find(item=>item.name===name);

	if (found) {
		const item = found.audioObj;
	
		item.loop = options.loop || false;
		item.volume = (options.fadeInDelay && '0') || (options.volume || 1);
	
		if (options.fadeInDelay) {
			recursivelyFadeIn(item, 10, options.fadeInDelay, options.volume);
		}
	
		item.play();
	
		return item;
	}

	return null;
}

export function stopSound(ary, name) {
	const found = ary.find(item=>item.name===name);
	if (found) {
		const item = found.audioObj;	
	
		item.pause();
		return item;
	}

	return null;
}

function recursivelyFadeIn(audioObj, totalSteps, delay, maxVolume=1, stepCount=0) {

	if (stepCount === totalSteps) return;

	const volumeStepDelay = delay/totalSteps,
		volumeStep = (stepCount/totalSteps) * maxVolume;

	window.setTimeout(()=>{
		audioObj.volume = volumeStep;
		recursivelyFadeIn(audioObj, totalSteps, delay, maxVolume, ++stepCount);
	}, volumeStepDelay);
}